// extracted by mini-css-extract-plugin
export default {"root":"g3nvu","separator":"ZNEE0","textActive":"BY4ur","textInactive":"cXSBX","widthAnimation":"oaOsn"};